export const environment = {
  production: true,
  buildId: '3494343535922391',
  configFile: 'config.json',
};
